export default "__VITE_ASSET__DCmPVKCI__"